import { css, cx } from "@emotion/css"

import Currency from "./Currency"

type Props = {
  className: string
  currencyClassName?: string
  currency: number | null
}

const TotalCell = ({ currency, className, currencyClassName }: Props) => {
  return (
    <div className={cx(styles.container, className)}>
      <Currency amountClassName={cx(styles.amount, currencyClassName)} currency={currency} />
    </div>
  )
}

export default TotalCell

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 39px;
    font-size: 13px;
    text-align: center;
  `,
  amount: css`
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
  `,
}
